import { render, staticRenderFns } from "./Cubes.vue?vue&type=template&id=6f6ce500&scoped=true"
import script from "./Cubes.vue?vue&type=script&lang=js"
export * from "./Cubes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ce500",
  null
  
)

export default component.exports